import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function projectManagement() {
    return request({
        url: V1_API_URL_PREFIX + "/project-management",
        method: 'GET'
    });
}

export function saveOrUpdateProjectManagement(record) {
    return request({
        url: V1_API_URL_PREFIX + "/project-management/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteProjectManagement(record) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/project-management/delete",
        method: 'DELETE',
        body: JSON.stringify(record)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function projectManagementRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/project-management/latestRevision",
        method: 'GET'
    });
}

export function addProjectManagementRevision(review) {
    return request({
        url: V1_API_URL_PREFIX + "/project-management/add/revision",
        method: 'POST',
        body: JSON.stringify(review)
    });
}